import {

  fan1,
  fan2,
  fan3,
  fan4,
  fan5,
  fan6,
  fan7,
  fan8,
  fan9,
  fan10,
  fan11,
  fan12,


  ac1,
  ac2,
  ac3,
  ac4,
  ac5,
  ac6,
  ac7,
  ac8,
  ac9,
  ac10,
  ac11,
  ac12,



  geyser1,
  geyser2,
  geyser3,
  geyser4,
  geyser5,
  geyser6,
  geyser7,
  geyser8,
  geyser9,
  geyser10,
  geyser11,
  geyser12,

  
  refrigerator1,
  refrigerator2,
  refrigerator3,
  refrigerator4,
  refrigerator5,
  refrigerator6,
  refrigerator7,
  refrigerator8,
  refrigerator9,
  refrigerator10,
  refrigerator11,
  refrigerator12,

  

  dispenser1,
  dispenser2,
  dispenser3,
  dispenser4,
  dispenser5,
  dispenser6,
  dispenser7,
  dispenser8,
  dispenser9,
  dispenser10,
  dispenser11,
  dispenser12,

  
} from "../assets/images/index";


export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "/contact",
  },
  {
    _id: 1006,
    title: "Products",
    dropdown: [
      { _id: 2001, title: "Fans", link: "/products/fans" },
      { _id: 2002, title: "AC", link: "/products/ac" },
      { _id: 2003, title: "Geyser", link: "/products/geyser" },
      { _id: 2004, title: "Dispenser", link: "/products/dispenser" },
      { _id: 2005, title: "Refrigerator", link: "/products/refrigerator" },
      
    ],
  },
  {
    _id: 1006,
    title: "PriceList",
    dropdown: [
      { _id: 2001, title: "FansPrice", link: "/pricelist/fansprice" },
      { _id: 2002, title: "AcPrice", link: "/pricelist/acprice" },
      { _id: 2003, title: "GeyserPrice", link: "/pricelist/geyserprice" },
      { _id: 2004, title: "DispenserPrice", link: "/pricelist/dispenserprice" },
      { _id: 2005, title: "RefrigeratorPrice", link: "/pricelist/refrigeratorprice" },
      { _id: 2005, title: "PriceList", link: "/pricelist/pricelist" },
    ],
  },
  {
    _id: 1005,
    title: "Offers",
    link: "/Offer",
  },
  {
    _id: 1007,
    title: "Feedback",
    link: "/feedback",
  },
  // {
  //   _id: 1006,
  //   title: "Products",
  //   dropdown: [
  //     { _id: 2001, title: "Fans", link: "/products/fans" },
  //     { _id: 2002, title: "AC", link: "/products/ac" },
  //     { _id: 2003, title: "Geyser", link: "/products/geyser" },
  //     { _id: 2004, title: "Dispenser", link: "/products/dispenser" },
  //     { _id: 2005, title: "Refrigerator", link: "/products/refrigerator" },
  //   ],
  // },
];


export const SplOfferData = [
  {
    _id: "201",
    img: fan1,
    productName: "Royal Deluxe Ceiling Fan",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
  },
  {
    _id:"202",
    img:geyser3,
    productName:"CANON ELECTRIC STORAGE GEYSER 60 LITER Model EWT-60",
    price:"30000",
    color:"CANON",
    badge:true,
    des:"The Canon EWT-60 is a 60-liter Electric Storage Geyser that operates on 220-240 volts and draws 2000 watts of power. It provides hot water quickly and maintains the temperature throughout the day. It also features an adjustable thermostat for temperature control."
  },
  {
    _id:"203",
    img:refrigerator10,
    productName:"HAIER E-STAR REFRIGERATOR NON INVERTER Model HRF-186 EBD",
    price:"64500",
    color:"HAIER",
    badge:true,
    des:" The HRF-186EBD is a single door refrigerator from the brand Haier. It’s designed for faster cooling and freezing with 1HIT technology. This refrigerator has a golden color and a total net capacity of 156 liters."
  },
  {
    _id: "204",
    img: ac4,
    productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2 ",
    price: "161700",
    color: "TCL",
    badge: false,
    des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
  },
];


export const paginationItems = [


  {
    _id: "1011",
    img: fan1,
    productName: "Royal Deluxe Ceiling Fan",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
  },
  {
    _id: "1013",
    img: ac1,
    productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
    price: "134700",
    color: "HAIER",
    badge: true,
    des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
  },
  {
    _id:"1101",
    img:dispenser4,
    productName:"DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED",
    price:"42000",
    color:"DAWLANCE",
    badge:true,
    des:"The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
},
{
  _id:"1101",
  img:dispenser1,
  productName:"DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED",
  price:"44100",
  color:"DAWLANCE",
  badge:true,
  des:"The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
},
{
  _id:"100001",
  img:geyser1,
  productName:"CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021",
  price:"25500",
  color:"CANON",
  badge:true,
  des:"The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
},
  {
    _id: "1012",
    img: fan2,
    productName: "Royal Saver Ceiling Fan",
    price: "10200",
    color: "Energy",
    badge: false,
    des: "SKU: Royal Smart Series ESF (White)-0000001Royal Energy Saver Fans are designed on the principle of conserving energy to preserve the planet. To ensure the provision of energy-efficient solutions, Royal Fans takes pride in manufacturing Pakistan's first energy saver fans that use less energy, and are not heavy on the electricity bills."
  },
  {
    _id: "1016",
    img: ac4,
    productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2",
    price: "161700",
    color: "TCL",
    badge: false,
    des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
  },
  {
    _id: "1013",
    img: fan3,
    productName: "Royal Hi-Standard Ceiling Fan",
    price: "8700",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Hi Standard Ceiling Fan-56/COPPER-(Off-White)-0000004Royal Deluxe Series are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
  },
  {
    _id: "1014",
    img: fan4,
    productName: "Royal Passion Ceiling Fan - GRACE",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Passion Ceiling Fans-56/COOPER-(Off-White Sheesham Wood)-0000004The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
  },
  {
    _id: "1015",
    img: fan5,
    productName: "Royal Petite Bracket Fan",
    price: "6900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Petite Bracket Fan-12/COPPER-(Off-White)-0000002Be it your corridor, terrace, lobby, or veranda, the Royal Petite Fan is the best fit any place where space is limited. With its small wing blades and alluring shades of pearl white and impressive black, this fan is a petite powerhouse."
  },
  {
    _id: "1016",
    img: fan6,
    productName: "Royal Platinum Ceiling Fan",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(Off-White)-0000003Royal Deluxe Series  are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
  },
  {
    _id: "1017",
    img: fan7,
    productName: "Royal Water Proof Ceiling Fan - Majesty",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Water Proof Ceiling Fans-56/COPPER-(Off-White)-0000002Our Water Proof Ceiling Fans are designed to work in open areas, mosques, etc. that are exposed to extreme weather conditions as well as to keep them safe from dust and moisture. If you are planning to invest in a fan that has the quality to perform well along with being waterproof, then you have come to the right place.      "
  },
  {
    _id: "1018",
    img: fan8,
    productName: "Royal RL-040- Smart Lifestyle ACDC Fan",
    price: "13200",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Lifestyle-RL-040(Off-White Sheesham Wood)-0000001Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
  },
  {
    _id: "1019",
    img: fan9,
    productName: "Royal RL-050 - Smart Lifestyle ACDC Fan",
    price: "13200",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Lifestyle-RL-050(Off White Pinewood)-0000003Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
  },
  {
    _id: "1020",
    img: fan10,
    productName: "Royal Smart Prime ACDC Ceiling Fan - Prime",
    price: "10200",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Smart Prime Ceiling Fans(Off-White)-0000003fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth"
  },
  {
    _id: "1021",
    img: fan11,
    productName: "Ornament - Smart Lifestyle ACDC Fan",
    price: "18600",
    color: "Ornament",
    badge: false,
    des: "SKU: Ornament 001Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
  },
  {
    _id: "1022",
    img: fan12,
    productName: "Royal Passion Grace - Prime ACDC Ceiling Fan",
    price: "10200",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Smart Passion ACDC Grace 00004Our Smart AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth"
  },
  {
    _id: "1011",
    img: fan1,
    productName: "Royal Deluxe Ceiling Fan",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
  },
  {
    _id: "1012",
    img: fan2,
    productName: "Royal Energy Saver Ceiling Fan",
    price: "10200",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Smart Series ESF (White)-0000001Royal Energy Saver Fans are designed on the principle of conserving energy to preserve the planet. To ensure the provision of energy-efficient solutions, Royal Fans takes pride in manufacturing Pakistan's first energy saver fans that use less energy, and are not heavy on the electricity bills."
  },
  {
    _id: "1013",
    img: fan3,
    productName: "Royal Hi-Standard Ceiling Fan",
    price: "8700",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Hi Standard Ceiling Fan-56/COPPER-(Off-White)-0000004Royal Deluxe Series are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
  },
  {
    _id: "1014",
    img: fan4,
    productName: "Royal Passion Ceiling Fan - GRACE",
    price: "9900",
    color: "Royal",
    badge: false,
    des: "SKU: Royal Deluxe Passion Ceiling Fans-56/COOPER-(Off-White Sheesham Wood)-0000004The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
  },

  {
    _id: "1013",
    img: ac1,
    productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
    price: "134700",
    color: "HAIER",
    badge: true,
    des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
  },
  {
    _id: "1014",
    img: ac2,
    productName: "HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W ",
    price: "163800",
    color: "HAIER",
    badge: false,
    des: "The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space.The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
  },
  {
      _id: "1015",
      img: ac3,
      productName: "KENWOOD 1.5 TON INVERTER AC Model KES-1862S",
      price: "150900",
      color: "KENWOOD",
      badge: true,
      des: "The KES-1862S is a 1.5 Ton Heat & Cool DC Inverter Wall Mount AC from the renowned brand Kenwood. This model offers a premium cooling and heating experience, ensuring your comfort all year round."
    },
    {
      _id: "1016",
      img: ac4,
      productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2 ",
      price: "161700",
      color: "TCL",
      badge: false,
      des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
    },
    {
      _id: "1017",
      img: ac5,
      productName: "MIDEA 1.5 TON DC INVERTER EXTREME AC Model MSAGC-18HRFN1 ",
      price: "171300",
      color: "MIDEA",
      badge: true,
      des: "The MSAGC-18HRFN1 is a 1.5 Ton Inverter Wall Mounted air conditioner from Midea. It’s part of the Xtreme series and comes with Wi-Fi capabilities. This air conditioner is known for its energy efficiency and cost-effectiveness."
    },
    {
      _id: "1018",
      img: ac6,
      productName: "TCL 1.5 TON T-PRO DC INVERTER AC Model TAC 18T3 PRO ",
      price: "183300",
      color: "TCL",
      badge: false,
      des: "The TAC-18T3-Pro is a 1.5 Ton DC Inverter from TCL, an upgraded version of the TCL Miracle Series. It offers a completely controlled refreshment with IoT Wi-Fi, allowing you to adjust the temperature and turn the AC off or on at any time from anywhere. The Hands-Free Voice Control feature on your TCL TV also lets you control the AC."
    },
    {
        _id: "1019",
        img: ac7,
        productName: "GREE 1.5 TON PULAR SERIES INVERTER SPLIT AC Model GS-18PITH11 W",
        price: "183300",
        color: "GREE",
        badge: true,
        des: "The GREE Split AC 1.5 TON Pular Series GS-18PITH11W offers efficient cooling and heating with G10 inverter technology, elegant design, and 3D airflow. This air conditioner ensures energy savings and comfort for your home."
      },
      {
        _id: "1020",
        img: ac8,
        productName: "GREE 1.0 TON PULAR SERIES INVERTER SPLIT AC Model GS-12PITH11W ",
        price: "149700",
        color: "GREE",
        badge: false,
        des: "The GREE Split AC 1 TON Pular Series GS-12PITH11W offers efficient cooling and heating with G10 inverter technology, elegant design, and 3D airflow. This air conditioner ensures energy savings and comfort for your home."
      },
    {
      _id: "1021",
      img: ac9,
      productName: "KENWOOD 1.5 TON EECO ULTRA T3 INVERTER AC Model KEE-1865S",
      price: "204900",
      color: "KENWOOD",
      badge: true,
      des: "The Kenwood KEE-1865S eECO Ultra is a 1.5-ton full DC inverter air conditioner that offers efficient cooling and heating with T3 technology. It’s equipped with advanced features like 3D airflow, Wifi, and voice control, ensuring optimal comfort in any weather condition."
    },
    {
      _id: "1022",
      img: ac10,
      productName: "HAIER 1.0 TON HEAT & COOL DC INVERTER AC Model HSU-12HFCA W",
      price: "134700",
      color: "HAIER",
      badge: false,
      des: "The Triple Inverter HSU-12HFCA/013USDC (W) is a high-quality air conditioner from Haier. It uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
    },
    {
      _id: "1023",
      img: ac11,
      productName: "HAIER 2.0 TON HEAT & COOL INVERTER WALL TYPE SPLIT AC Model HSU-24HFCD W",
      price: "231900",
      color: "HAIER",
      badge: true,
      des: "The Triple Inverter HSU-24HFCD/012USDC (W) is a high-quality air conditioner from Haier. It uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
    },
    {
      _id: "1024",
      img: ac12,
      productName: "MIDEA 1.0 TON BREEZELESS E INVERTER SPLIT AC Model MSCB1BU-12HRFN8  ",
      price: "146400",
      color: "MIDEA",
      badge: false,
      des: "The Midea Breezeless E combines sophistication and functionality with its innovative design. It features advanced inverter technology for precise temperature control and whisper-quiet operation."
    },
    {
      _id: "1013",
      img: ac1,
      productName: "HAIER 1.0 TON TRIPLE INVERTER AC Model HSU-12HFCS W",
      price: "134700",
      color: "HAIER",
      badge: true,
      des: "The Haier Triple Inverter HSU-12HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
    },
    {
      _id: "1014",
      img: ac2,
      productName: "HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W",
      price: "163800",
      color: "HAIER",
      badge: false,
      des: "The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space.The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
    },
    {
        _id: "1015",
        img: ac3,
        productName: "KENWOOD 1.5 TON INVERTER AC Model KES-1862S ",
        price: "150900",
        color: "KENWOOD",
        badge: true,
        des: "The KES-1862S is a 1.5 Ton Heat & Cool DC Inverter Wall Mount AC from the renowned brand Kenwood. This model offers a premium cooling and heating experience, ensuring your comfort all year round."
      },
      {
        _id: "1016",
        img: ac4,
        productName: "TCL 1.5 TON EXTERME SERIES DC INVERTER SPLIT AC Model TAC-18HEF-2",
        price: "161700",
        color: "TCL",
        badge: false,
        des: "The Extreme Series - 18HEF-2 is a powerful 1.5-ton DC inverter air conditioner designed for efficient cooling and heating. Its advanced technology ensures energy savings and reliable performance even in extreme temperatures."
      },

      {
        _id:"1101",
        img:dispenser1,
        productName:"DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED",
        price:"44100",
        color:"DAWLANCE",
        badge:true,
        des:"The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
    },
      {
        _id:"1102",
        img:dispenser2,
        productName:"DAWLANCE THREE TAPS WATER DISPENSER Model 1051 GLASS DOOR CLOUD WHITE",
        price:"45300",
        color:"DAWLANCE",
        badge:true,
        des:"The 1051 Glass Door Cloud White With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and normal water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
    },
    {
        _id:"1103",
        img:dispenser3,
        productName:"MIDEA THREE TAPS WATER DISPENSER Model YL-2037S BLACK",
        price:"39600",
        color:"MMIDEA",
        badge:true,
        des:"The Midea YL-2037S-B is a user-friendly water dispenser with a sleek design. It offers hot, normal, and cold water options, and is equipped with a refrigerator for added convenience."
    },
      {
        _id:"1104",
        img:dispenser4,
        productName:"PEL TWO TAP WATER DISPENSER Model 525 CURVED GLASSDOOR PURPLE BLAZE",
        price:"37500",
        color:"PEL",
        badge:true,
        des:"The PEL 525 Curved Glassdoor Dispenser is a sleek and efficient water dispenser, designed for modern households. It offers quick cooling and heating, a built-in refrigerator, and a stylish curved glass door. The dispenser is available in multiple colors, adding a touch of elegance to your space."
    },
    {
        _id:"1105",
        img:dispenser5,
        productName:"ORIENT THREE TAP WATER DISPENSER Model CRYSTAL 3 SR",
        price:"38700",
        color:"ORIENT",
        badge:true,
        des:"The Orient Crystal 3 Taps Red Glass Door Water Dispenser is a stylish and functional water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
    },
      {
        _id:"1106",
        img:dispenser6,
        productName:"DAWLANCE THREE TAP WATER DISPENSER Model 1051 BEIGE",
        price:"44100",
        color:"DAWLANCE",
        badge:true,
        des:"The 1051 Glass Door Beige With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
    },
    {
        _id:"1107",
        img:dispenser7,
        productName:"ORIENT THREE TAPS WATER DISPENSER Model ICON 3 TAPS BLACK",
        price:"36300",
        color:"ORIENT",
        badge:true,
        des:"The Icon 3 Taps Black Water Dispenser is a versatile, high-performance water dispenser with a sleek black design. It offers hot, cold, and room temperature water options, ensuring you have access to water at your preferred temperature. This dispenser also features a mini-fridge, providing additional storage space."
    },
      {
        _id:"1108",
        img:dispenser8,
        productName:"ORIENT THREE TAP WATER DISPENSER Model CRYSTAL 3 SP",
        price:"38700",
        color:"ORIENT",
        badge:true,
        des:"The Crystal 3 Taps Purple Glass Door Water Dispenser is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a stylish purple glass door. The child safety lock provides added safety, especially for households with children."
    },
    {
        _id:"1109",
        img:dispenser9,
        productName:"DAWLANCE THREE TAPS WATER DISPENSER Model WD 1051 SILVER",
        price:"44100",
        color:"DAWLANCE",
        badge:true,
        des:"The WD 1051 SILVER is a high-quality water dispenser from Dawlance. It features a sleek design and provides efficient cooling and heating performance. This dispenser offers hot, normal, and cold water options, making it a versatile addition to any home or office."
    },
      {
        _id:"1110",
        img:dispenser10,
        productName:"DAWLANCE THREE TAPS GLASS DOOR WATER DISPENSER Model DBD-1035GD",
        price:"50700",
        color:"DAWLANCE",
        badge:true,
        des:"The DBD-1035 Glass Door Bottom Load Water Dispenser is a high-quality, efficient appliance from Dawlance. It features a sleek glass front design and a bottom load water bottle system for convenience. This dispenser provides hot, cold, and room temperature water options, perfect for any home or office setting."
    },
    {
        _id:"1111",
        img:dispenser11,
        productName:"ORIENT WATER DISPENSER Model ICON 3 MESH GREY",
        price:"36300",
        color:"ORIENT",
        badge:true,
        des:"The Orient Icon 3 Taps Grey Water Dispenser is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
    },
      {
        _id:"1112",
        img:dispenser12,
        productName:"SUPER ASIA THREE TAP WATER DISPENSER Model HC-56BORIENT THREE TAP WATER DISPENSER Model FLARE3 RG",
        price:"37200",
        color:"SUPER ASIA",
        badge:true,
        des:"The HC-56B water dispenser from Super Asia features an elegant tempered double glass door. It offers easy water dispensing with three taps (cold, hot, and normal). The dispenser also includes LED night lights for convenience. With a large stainless steel water tank and a 20-liter refrigerator capacity, it’s a practical addition to any home or office."
    },
    {
      _id:"1101",
      img:dispenser1,
      productName:"DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED",
      price:"44100",
      color:"DAWLANCE",
      badge:true,
      des:"The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
  },
    {
      _id:"1102",
      img:dispenser2,
      productName:"DAWLANCE THREE TAPS WATER DISPENSER Model 1051 GLASS DOOR CLOUD WHITE",
      price:"45300",
      color:"DAWLANCE",
      badge:true,
      des:"The 1051 Glass Door Cloud White With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and normal water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
  },
  {
      _id:"1103",
      img:dispenser3,
      productName:"MIDEA THREE TAPS WATER DISPENSER Model YL-2037S BLACK",
      price:"39600",
      color:"MMIDEA",
      badge:true,
      des:"The Midea YL-2037S-B is a user-friendly water dispenser with a sleek design. It offers hot, normal, and cold water options, and is equipped with a refrigerator for added convenience."
  },
    {
      _id:"1104",
      img:dispenser4,
      productName:"PEL TWO TAP WATER DISPENSER Model 525 CURVED GLASSDOOR PURPLE BLAZE",
      price:"37500",
      color:"PEL",
      badge:true,
      des:"The PEL 525 Curved Glassdoor Dispenser is a sleek and efficient water dispenser, designed for modern households. It offers quick cooling and heating, a built-in refrigerator, and a stylish curved glass door. The dispenser is available in multiple colors, adding a touch of elegance to your space."
  },

  {
    _id:"100001",
    img:geyser1,
    productName:"CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021",
    price:"25500",
    color:"CANON",
    badge:true,
    des:"The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
  },
  {
    _id:"100002",
    img:geyser2,
    productName:"CANON INSTANT GAS GEYSER Model IGWH-16DD",
    price:"19800",
    color:"CANON",
    badge:true,
    des:"The INS-16DD PLUS NG is an instant water geyser from Canon. It’s designed with a silver paint cover, grey bottom cover, and an ultra-low water-pressure start system. It also features flame out protection and battery auto ignition for safety and efficiency."
  },
  {
    _id:"100003",
    img:geyser3,
    productName:"CANON ELECTRIC STORAGE GEYSER 60 LITER Model EWT-60 ",
    price:"30000",
    color:"CANON",
    badge:true,
    des:"The Canon EWT-60 is a 60-liter Electric Storage Geyser that operates on 220-240 volts and draws 2000 watts of power. It provides hot water quickly and maintains the temperature throughout the day. It also features an adjustable thermostat for temperature control."
  },
  {
    _id:"100004",
    img:geyser4,
    productName:"Geyser MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L",
    price:"26700",
    color:"Geyser",
    badge:true,
    des:" The MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L is a robust and efficient water heater with a 60-liter capacity. It’s designed for efficient temperature control and comes with a safety valve. The product is built to last, offering a 1-year warranty."
  },
  {
    _id:"100005",
    img:geyser5,
    productName:"ARISTON ELECTRIC STORAGE GEYSER 50 LITRE Model 50L- BLU R V",
    price:"80700",
    color:"ARISTON",
    badge:true,
    des:"The ARISTON 50L- BLU R V is a 50-liter electric storage water heater designed in Italy. It features a modern shape and high-quality materials, with sleek aesthetic finishes that make it an interior design item."
  },
  {
    _id:"100006",
    img:geyser6,
    productName:"SUPER ASIA ELECTRIC GEYSER 30 LITER Model MEH-30 ",
    price:"42000",
    color:"SUPER ASIA",
    badge:true,
    des:" The SUPER ASIA MEH-30 is a 30-liter electric water heater that provides instant and continuous hot water. It’s designed with an efficient heating system and precision thermostat control, ensuring energy efficiency and safety."
  },
  {
    _id:"100007",
    img:geyser7,
    productName:"CANON INSTANT GAS GEYSER 10 LITER Model 20DD LPG",
    price:"33300",
    color:"CANON",
    badge:true,
    des:"The CANON INSTANT GEYSER 10 LITER Model 20DD LPG is a wall-mounted gas water heater that provides instant, continuous, and abundant hot water. It’s designed with modern technology and optimal fuel consumption, ensuring energy efficiency and safety."
  },
  {
    _id:"100008",
    img:geyser8,
    productName:"SUPER ASIA INSTANT GAS GEYSER 6 LITRE Model GH-106 DI LPG ",
    price:"180000",
    color:"SUPER ASIA",
    badge:true,
    des:" The GH-106 DI LPG is a 6-liter instant gas geyser from Super Asia. It’s designed for quick heating, providing hot water as soon as you need it. The product is built with safety and efficiency in mind, ensuring a reliable and comfortable experience."
  },
  {
    _id:"100009",
    img:geyser9,
    productName:"SUPER ASIA ELECTRIC STORAGE GEYSER 10 LITER Model SEH-10",
    price:"23400",
    color:"SUPER ASIA",
    badge:true,
    des:"The Super Asia SEH-10 is a 10-liter electric water heater that provides a reliable and efficient solution for your hot water needs. It’s designed with an enamel coated tank and heating element for durability, and features a range of safety protections to ensure safe operation."
  },
  {
    _id:"1000010",
    img:geyser10,
    productName:"SUPER ASIA ELECTRIC & GAS GEYSER 30 GALLON Model GEH735-AI ",
    price:"62400",
    color:"SUPER ASIA",
    badge:true,
    des:" The GEH735-AI is a versatile 35-gallon electric and gas geyser from Super Asia. It offers dual functionality, allowing you to choose between gas and electric operation to suit your needs. With its large capacity, it provides plenty of hot water for daily use. The GEH735-AI combines advanced technology with reliable performance, ensuring quick and efficient heating."
  },
  {
    _id:"1000011",
    img:geyser11,
    productName:"CANON FAST ELECTRIC GEYSER 30 LITER Model EWH-30 LCM",
    price:"31500",
    color:"CANON FAST",
    badge:true,
    des:"The Canon Fast Electric Geyser 30 Liter EWH-30LCM offers rapid heating and a spacious 30-liter capacity, making it ideal for large households. Its advanced safety features and energy-efficient operation ensure reliable and safe hot water supply."
  },
  {
    _id:"1000012",
    img:geyser12,
    productName:"ARISTON ELECTRIC STORAGE GEYSER 80 LITRE Model 80L BLU R V ",
    price:"102300",
    color:"ARISTON",
    badge:true,
    des:" The Ariston 80L Blur V is a high-efficiency electric storage geyser designed to provide reliable hot water. It features a sleek, modern design with advanced safety and insulation features, making it a great addition to any home."
  },
  {
    _id:"100001",
    img:geyser1,
    productName:"CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021 ",
    price:"25500",
    color:"CANON",
    badge:true,
    des:"The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
  },
  {
    _id:"100002",
    img:geyser2,
    productName:"CANON INSTANT GAS GEYSER Model IGWH-16DD",
    price:"19800",
    color:"CANON",
    badge:true,
    des:"The INS-16DD PLUS NG is an instant water geyser from Canon. It’s designed with a silver paint cover, grey bottom cover, and an ultra-low water-pressure start system. It also features flame out protection and battery auto ignition for safety and efficiency."
  },
  {
    _id:"100003",
    img:geyser3,
    productName:"CANON ELECTRIC STORAGE GEYSER 60 LITER Model EWT-60",
    price:"30000",
    color:"CANON",
    badge:true,
    des:"The Canon EWT-60 is a 60-liter Electric Storage Geyser that operates on 220-240 volts and draws 2000 watts of power. It provides hot water quickly and maintains the temperature throughout the day. It also features an adjustable thermostat for temperature control."
  },
  {
    _id:"100004",
    img:geyser4,
    productName:"Geyser MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L",
    price:"26700",
    color:"Geyser",
    badge:true,
    des:" The MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L is a robust and efficient water heater with a 60-liter capacity. It’s designed for efficient temperature control and comes with a safety valve. The product is built to last, offering a 1-year warranty."
  },

  {
    _id:"100003",
    img:refrigerator1,
    productName:"DAWLANCE TWO DOOR INVERTER REFRIGERATOR Model 91999 GRAZE+ GEM BLACK",
    price:"149700",
    color:"DAWLANCE",
    badge:true,
    des:"The Dawlance 91999 Graze+Gem Black Refrigerator combines sophistication and functionality. Its spacious storage and energy-efficient performance make it a must-have for contemporary households."
  },
  {
    _id:"100004",
    img:refrigerator2,
    productName:"HAIER BEDROOM NON INVERTER REFRIGERATOR Model HR-66B",
    price:"35400",
    color:"HAIER",
    badge:true,
    des:" The Haier HR-66B is a compact, single-door refrigerator designed for bedroom use. With a capacity of 66 liters, it offers ample storage for your essentials. Its sleek black design and low-noise operation make it a perfect addition to any room."
  },
  {
    _id:"100005",
    img:refrigerator3,
    productName:"DAWLANCE NON INVERTER REFRIGERATOR Model 91999 CHROME HB",
    price:"123000",
    color:"DAWLANCE",
    badge:true,
    des:"The 91999 Chrome Hairline Black is a double door refrigerator from Dawlance. It’s designed with a sleek chrome hairline black finish and offers a spacious interior for all your food storage needs. It uses Vitamin Fresh Technology to preserve the maximum level of Vitamin A and C in fruits and vegetables, ensuring the health and immunity of your family."
  },
  {
    _id:"100006",
    img:refrigerator4,
    productName:"EASTCOOL BEDROOM NON INVERTER REFRIGERATOR Model TM542-18",
    price:"40200",
    color:"EASTCOOL",
    badge:true,
    des:" The Eastcool Refrigerator TM-542-08 is a compact, energy-efficient refrigerator with a unique lamp curved door design. It offers a 4 CUFT capacity and comes in various decorative colors."
  },
  {
    _id:"100007",
    img:refrigerator5,
    productName:"DAWLANCE BEDROOM SINGLE DOOR REFRIGERATOR Model 9106SD SILVER BLACK",
    price:"50100",
    color:"DAWLANCE",
    badge:true,
    des:"The Dawlance 9106 SD 6 Cu.ft silver black is a single door bedroom refrigerator that offers a compact yet spacious storage solution. It features Direct Cool technology and an inner freezer compartment for efficient cooling. The refrigerator is aesthetically appealing, complementing your bedroom’s ambiance."
  },
  {
    _id:"100008",
    img:refrigerator6,
    productName:"DAWLANCE VERTICAL FREEZER INVERTER Model VF 1035WB AVANTE+ GD CW",
    price:"113100",
    color:"DAWLANCE",
    badge:true,
    des:" The Dawlance Vertical Freezer Inverter 1035WB GD Avante+ is a space-saving freezer designed for efficient cooling and energy saving. It features Inverter Technology and operates on as low as 120V, providing reliable performance and long-lasting freshness."
  },
  {
    _id:"100009",
    img:refrigerator7,
    productName:"HAIER TWIN INVERTER + REFRIGERATOR Model HRF-538TIFRA",
    price:"146700",
    color:"HAIER",
    badge:true,
    des:"The Haier HRF-538TIFRA-Twin Inverter + is a cutting-edge refrigerator that combines superior cooling and energy efficiency. It’s equipped with Twin Inverter Technology and Twin Turbo Fans Technology for optimal performance, and A.SPE Sterilization Technology to keep your food fresh."
  },
  {
    _id:"1000010",
    img:refrigerator8,
    productName:"HAIER E-STAR REFRIGERATOR NON INVERTER Model HRF-186EBS",
    price:"65400",
    color:"HAIER",
    badge:true,
    des:" The HRF-186EBS is a single door refrigerator from the brand Haier. It’s designed for faster cooling and freezing with 1HIT technology. This refrigerator has a golden color and a total net capacity of 156 liters."
  },
  {
    _id:"1000011",
    img:refrigerator9,
    productName:"DAWLANCE TWO DOOR REFRIGERATOR INVERTER Model 91999 AVANTE+ CW",
    price:"147600",
    color:"DAWLANCE",
    badge:true,
    des:"The 91999 Avante+ Cloud White is a double door refrigerator from Dawlance, offering a sleek design and up to 10% more storage space. It’s equipped with advanced features for efficient cooling and energy saving."
  },
  {
    _id:"1000012",
    img:refrigerator10,
    productName:"HAIER E-STAR REFRIGERATOR NON INVERTER Model HRF-186 EBD",
    price:"64500",
    color:"HAIER",
    badge:true,
    des:" The HRF-186EBD is a single door refrigerator from the brand Haier. It’s designed for faster cooling and freezing with 1HIT technology. This refrigerator has a golden color and a total net capacity of 156 liters."
  },
  {
    _id:"1000013",
    img:refrigerator11,
    productName:"HAIER DIGITAL INVERTER REFRIGERATOR Model HRF-438IFRA",
    price:"132600",
    color:"HAIER",
    badge:true,
    des:"The Haier HRF-438IFRA is a digital inverter refrigerator that operates on a wide voltage range. It comes with a digital control system and four temperature sensors for optimal performance."
  },
  {
    _id:"1000014",
    img:refrigerator12,
    productName:"HAIER REFRIGERATOR TWIN INVERTER IOT Model HRF-538TIFGU1",
    price:"153000",
    color:"HAIER",
    badge:true,
    des:" The Twin Inverter IOT HRF-538TIFGU1 is a high-capacity refrigerator from Haier, launched in 2024. It features IoT technology, twin turbo fans, and A.SPE sterilization technology."
  },
  {
    _id:"100003",
    img:refrigerator1,
    productName:"DAWLANCE TWO DOOR INVERTER REFRIGERATOR Model 91999 GRAZE+ GEM BLACK",
    price:"149700",
    color:"DAWLANCE",
    badge:true,
    des:"The Dawlance 91999 Graze+Gem Black Refrigerator combines sophistication and functionality. Its spacious storage and energy-efficient performance make it a must-have for contemporary households."
  },
  {
    _id:"100004",
    img:refrigerator2,
    productName:"HAIER BEDROOM NON INVERTER REFRIGERATOR Model HR-66B",
    price:"35400",
    color:"HAIER",
    badge:true,
    des:" The Haier HR-66B is a compact, single-door refrigerator designed for bedroom use. With a capacity of 66 liters, it offers ample storage for your essentials. Its sleek black design and low-noise operation make it a perfect addition to any room."
  },
  {
    _id:"100005",
    img:refrigerator3,
    productName:"DAWLANCE NON INVERTER REFRIGERATOR Model 91999 CHROME HB",
    price:"123000",
    color:"DAWLANCE",
    badge:true,
    des:"The 91999 Chrome Hairline Black is a double door refrigerator from Dawlance. It’s designed with a sleek chrome hairline black finish and offers a spacious interior for all your food storage needs. It uses Vitamin Fresh Technology to preserve the maximum level of Vitamin A and C in fruits and vegetables, ensuring the health and immunity of your family."
  },
  {
    _id:"100006",
    img:refrigerator4,
    productName:"EASTCOOL BEDROOM NON INVERTER REFRIGERATOR Model TM542-18",
    price:"40200",
    color:"EASTCOOL",
    badge:true,
    des:" The Eastcool Refrigerator TM-542-08 is a compact, energy-efficient refrigerator with a unique lamp curved door design. It offers a 4 CUFT capacity and comes in various decorative colors."
  },

  
  
];
